import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AdminApp } from "./AdminApp";

// The Rebase admin uses `useBlocker`, which requires a DATA router.
const router = createBrowserRouter([
    {
        path: "/*",
        element: <AdminApp />
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <RouterProvider router={router} />
);
